import type { KambiListView } from '@mobi/api-types/kambi'
import { simpleFetchWithLogging } from '../simpleFetchWithLogging'

export function getEventsForCompetition(
  sport: string,
  region: string,
  competition: string,
  categoryId?: number,
  includeParticipants = true
) {
  let query = `?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true&includeParticipants=${includeParticipants}`
  if (categoryId) {
    query = query + `&category=${categoryId}`
  }

  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${competition}/all/matches${query}`
  )
}

export function getFuturesEventsForCompetition(sport: string, region: string, league: string) {
  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}/${region}/${league}/all/competitions.json?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true`
  )
}

export function getSearchResult(searchPath: string) {
  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView${searchPath}?lang=en_AU&market=AU&useCombined=true&useCombinedLive=true`
  )
}

export function getEventsBySportTermKey(sport: string, categoryId?: number) {
  let query = 'lang=en_AU&market=AU&includeParticipants=true'
  if (categoryId) {
    query = query + `&category=${categoryId}`
  }

  return simpleFetchWithLogging<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/${sport}?${query}`
  )
}
